import { configSystemReducer } from "../reducer/ConfigSystemReducer";

export const reducer = configSystemReducer;